// -- [Standard marketing section shell]

import type { ReactNode } from 'react'

type SectionBg = 'white' | 'muted' | 'subtle' | 'none'

const BG_CLASS: Record<SectionBg, string> = {
  white: 'bg-white',
  muted: 'bg-surface-muted',
  subtle: 'bg-surface-subtle',
  none: '',
}

interface SectionProps {
  id?: string
  children: ReactNode
  bg?: SectionBg
  /** -- Narrower content column (FAQ, CTA) */
  narrow?: boolean
  className?: string
}

export function Section({
  id,
  children,
  bg = 'white',
  narrow = false,
  className = '',
}: SectionProps) {
  return (
    <section
      id={id}
      className={`py-12 md:py-16 px-6 ${BG_CLASS[bg]} ${className}`}
    >
      <div className={`mx-auto ${narrow ? 'max-w-3xl' : 'max-w-6xl'}`}>
        {children}
      </div>
    </section>
  )
}
